import React from 'react'
import { Outlet } from 'react-router-dom';
import Home from '../pages/Home/Home';
import ScrollToTop from '../shared/ScrollToTop';

export default function Root() {
          document.title = 'বগুড়া পলিটেকনিক ইন্সটিটিউট';
          return (
                    <>
                              <Home />
                              <ScrollToTop />
                              <Outlet />
                    </>
          )
}
